import { addDays, addHours, addMinutes, isBefore, startOfDay, startOfHour, startOfMinute } from 'date-fns';

// TODO: По возможности подумать над временем и поясами.

export namespace IcuDay {
  let startOfDayOffset = 9 * 60;

  export function setStartOfDayOffset(valueMinutes: number) {
    startOfDayOffset = valueMinutes;
  }

  export function startOfReanimationDay(date: Date): Date {
    let result: Date;
    if (date.getHours() >= 0 && date.getHours() < startOfDayOffset / 60) {
      result = addMinutes(addDays(startOfDay(date), -1), startOfDayOffset);
    } else {
      result = addMinutes(startOfDay(date), startOfDayOffset);
    }
    return result;
  }

  /**
   * Начало реанимационных суток, которые НАЧИНАЮТСЯ в эту календарную дату.
   *
   * Отличается от startOfReanimationDay: та для времени до смещения (00:00-08:59 при
   * начале суток в 9:00) возвращает предыдущие сутки, потому что отвечает на вопрос
   * «в каких сутках находится этот момент». Здесь вопрос другой — «во сколько начинаются
   * сутки этой даты»: дата выбрана пользователем в календаре и означает именно их.
   */
  export function startOfReanimationDayOn(date: Date): Date {
    return addMinutes(startOfDay(date), startOfDayOffset);
  }

  export function endOfReanimationDay(date: Date): Date {
    if (date.getHours() >= 0 && date.getHours() < startOfDayOffset / 60) {
      return addMinutes(startOfDay(date), startOfDayOffset);
    }

    return addMinutes(addDays(startOfDay(date), 1), startOfDayOffset);
  }

  /**
   * Начало назначения по умолчанию: следующий полный час, если он ещё в текущих реанимационных
   * сутках, иначе — сейчас с точностью до минуты. Без этого с 08:00 до 09:00 (сутки с 09:00)
   * подставлялось 09:00, и назначение уходило в следующие сутки — на карте текущих его не видно.
   */
  export function defaultPrescriptionStart(now: Date): Date {
    const nextHour = addHours(startOfHour(now), 1);
    return isBefore(nextHour, endOfReanimationDay(now)) ? nextHour : startOfMinute(now);
  }
}
